import React from 'react'
import SavingImg1 from '../../Images/SavingImg/JesthaNagarikSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const JestaNagarikSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>जेष्ठ नागरीक बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>संस्थाका ६० वर्ष उमेर समुहका सदस्यहरूले ऐच्छिक रूपमा बचत गर्न सक्ने ।</li>
                                        <li>ऐच्छिक बचत सरह रकम राख्न झिक्न सकिने ।</li>
                                        <li>अरु चल्ती खाताहरू भन्दा ब्याजदर बढी प्रदान गरिने ।</li>
                                        <li>७५ वर्ष उमेर पूरा भएपछि अनिवार्य बचतको रकम जेष्ठ नागरिक बचत खातामा सारीने </li>
                                        <li>तिर्थाटनमा सहभागी गराईने ।</li>
                                        <li>ब्याजलाई संरक्षित पूँजी फिर्ता कोष वितरणमा गणना गरिने ।</li>
                                        <li>जेष्ठ सदस्य सम्मान कार्यक्रममा संलग्न गराईने ।</li>
                                        <li>खातामा न्युनतम मौज्दात रु २००।– राखि बाँकी फिर्ता लान सकिनेछ ।</li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default JestaNagarikSaving